// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_2O59V","content":"index_content_3-2d9"};